/** sessionStorage key for production dev API access (`X-Dev-Key`). */
const STORAGE_KEY = "memes-dev-key";

export function getDevKey(): string {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
}

export function setDevKey(key: string): void {
  try {
    if (key.trim()) sessionStorage.setItem(STORAGE_KEY, key.trim());
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* private browsing */
  }
}

export function devHeaders(): HeadersInit {
  const key = getDevKey();
  return key ? { "X-Dev-Key": key } : {};
}

/** Append dev key for EventSource URLs (cannot set custom headers). */
export function withDevKeyQuery(url: string): string {
  const key = getDevKey();
  if (!key) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}devKey=${encodeURIComponent(key)}`;
}
